export enum FundQueryQueryState {
  Success = 'success',
  Failed = 'failed',
}
